import type { IFetcher } from "../../util/io/Fetcher";
import type { GetNewsMenuResponse } from "../responses/GetNewsMenuResponse";
import type { GetEnvironmentAndCountryInfoResponse } from "../responses/GetEnvironmentAndCountryInfoResponse";

export interface IPOW3Fetchers {
	getNewsMenu(): Promise<GetNewsMenuResponse>;

	getEnvironmentAndCountryInfo(): Promise<GetEnvironmentAndCountryInfoResponse>;
}

export class POW3Fetchers implements IPOW3Fetchers {
	constructor(private readonly fetcher: IFetcher) {}

	async getNewsMenu(): Promise<GetNewsMenuResponse> {
		const { fetcher } = this;
		const url = "/POW3/Resource/BannerInfo";
		return await fetcher.getJSON<GetNewsMenuResponse>(url);
	}

	async getEnvironmentAndCountryInfo(): Promise<GetEnvironmentAndCountryInfoResponse> {
		const { fetcher } = this;
		const url = "/POW3/Account/GetEnvironmentAndCountryInfo";
		return await fetcher.getJSON<GetEnvironmentAndCountryInfoResponse>(url);
	}
}
